<template>  
    <section class="blockElement p-0 loginLoader">
        <div class="container-fluid">
            <div class="innerInclude">
                <div class="p_login">
                    <div class="row">
                        <div class="mobileLogo d-md-none">
                            <router-link :to="'/'" class="green">
                                <img src="../../../../static/fxView/images/fxview_chris_logo.png" alt="fxView">
                            </router-link>
                        </div> 
                        <div class="col-12 col-md-6 col-xl-4 text-center d-flex vh_100 flex-wrap blueBG beforeBG justify-content-center align-items-center ">
                            <div class="w-100"> 
                                <div class="titleArera Loginlogo">
                                    <router-link :to="'/'" class="green">
                                        <img src="../../../../static/fxView/images/fxview_chris_logo_white.png" alt="fxView">
                                    </router-link>
                                </div>


                                <div class="slider-sec">
                                    <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                                        <div class="carousel-inner">
                                            <div class="carousel-item active">
                                                <div class="titleArera">
                                                    <h2 class="medium mb-5">{{ $t('fxMultiRegulated') }} <span class="bold d-block">{{ $t('fxAwardWinningBroker') }}</span></h2>
                                                </div>
                                                <div class="award-sec d-flex flex-wrap justify-content-center">
                                                    <div class="award-item text-center mb-4 pb-2">
                                                        <img class="img-fluid mb-1"
                                                            src="../../../../static/fxView/images/best2021.svg" />
                                                        <h3 class="mb-1 text-white">{{ $t('fxBestValueBroker') }}</h3>
                                                        <p class="m-0">{{ $t('fxForexExpo') }}<span class="d-block">{{ $t('fxDubai') }}</span></p>
                                                    </div>

                                                    <div class="award-item text-center mb-4 pb-2">
                                                        <img class="img-fluid mb-1"
                                                            src="../../../../static/fxView/images/most2022.svg" />
                                                        <h3 class="mb-1 text-white">{{$t('fxMostTrustedBroker')}}</h3>
                                                        <p class="m-0">{{$t('fxUltimateFintech')}}<span class="d-block">{{ $t('fxCyprus') }}</span>
                                                        </p>
                                                    </div>

                                                    <div class="award-item text-center mb-4 pb-2">
                                                        <img class="img-fluid mb-1"
                                                            src="../../../../static/fxView/images/best-cfd-2022.svg" />
                                                        <h3 class="mb-1 text-white">{{$t('fxBestGlobalCFDBroker')}}</h3>
                                                        <p class="m-0">{{ $t('fxForexExpo') }}<span class="d-block">{{ $t('fxDubai') }}</span></p>
                                                    </div>

                                                    <div class="award-item text-center mb-4 pb-2">
                                                        <img class="img-fluid mb-1"
                                                            src="../../../../static/fxView/images/best-ecn-stp2023.svg" />
                                                        <h3 class="mb-1 text-white">{{$t('fxBestECNSTPBroker')}}</h3>
                                                        <p class="m-0">{{ $t('fxUFAwardsMEA') }}<span class="d-block">{{ $t('fxDubai') }}</span></p>
                                                    </div>
                                                    <div class="award-item text-center mb-4 pb-2">
                                                        <img class="img-fluid mb-1"
                                                            src="../../../../static/fxView/images/best-ecn-stp2023.svg" />
                                                        <h3 class="mb-1 text-white">{{ $t('fxBestMultiAssetBroker') }}</h3>
                                                        <p class="m-0">{{$t('fxFAME')}}<span class="d-block">{{ $t('fxSouthAfrica') }}</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        <div class="carousel-item">
                                            <div class="loginNewSection  ">
                                                <div class="loginSpreads d-flex">
                                                    <div class="d-flex position-relative InnerLogin">
                                                        <div class="loginIcon">
                                                            <figure>
                                                                <img src="../../../../static/fxView/images/Spreads.png" alt="">  
                                                            </figure>                                     
                                                        </div>
                                                        <div class="LoginContent  text-left" v-html="$t('reg_welcomemsg1')"></div>
                                                    </div>
                                                </div>
                                                <div class="loginSpreads d-flex ">
                                                    <div class="d-flex position-relative InnerLogin">
                                                        <div class="loginIcon">
                                                            <figure>
                                                                <img src="../../../../static/fxView/images/Commission.png" alt="">  
                                                            </figure>                                     
                                                        </div>
                                                        <div class="LoginContent text-right" v-html="$t('reg_welcomemsg2')"></div>
                                                    </div>
                                                </div>
                                                <div class="loginSpreads d-flex">
                                                    <div class="d-flex position-relative InnerLogin">
                                                        <div class="loginIcon">
                                                            <figure>
                                                                <img src="../../../../static/fxView/images/TradingTools.png" alt="">  
                                                            </figure>                                     
                                                        </div>
                                                        <div class="LoginContent text-left" v-html="$t('reg_welcomemsg3')"></div>
                                                    </div>
                                                </div>
                                                <div class="loginSpreads d-flex ">
                                                        <div class="d-flex position-relative InnerLogin">
                                                        <div class="loginIcon">
                                                            <figure>
                                                                <img src="../../../../static/fxView/images/FastExecution.png" alt="">  
                                                            </figure>                                     
                                                        </div>
                                                        <div class="LoginContent text-right" v-html="$t('reg_welcomemsg4')"></div>
                                                    </div>
                                                </div>
                                                <div class="loginSpreads d-flex">
                                                    <div class="d-flex position-relative InnerLogin">
                                                        <div class="loginIcon">
                                                            <figure>
                                                                <img src="../../../../static/fxView/images/DepositBonus.png" alt="">  
                                                            </figure>                                     
                                                        </div>
                                                        <div class="LoginContent text-left" v-html="$t('reg_welcomemsg5')"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <ol class="carousel-indicators">
                                            <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                                            <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-12 col-md-4 text-center d-flex vh_100 align-items-center blueBG beforeBG">
                            <div class="titleArera Loginlogo">
                                <img src="../../../../static/fxView/images/fxview_logo_white.svg" alt="fxView">
                            </div>
                            <div class="PortfoliosTitle"> 
                                <div id="demo" class="carousel slide fxRegisterSteps " data-ride="carousel"> 
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <p>{{ $t('welcomeMsg') }}</p>
                                            <img src="../../../../static/fxView/images/login_trading_platform.svg" alt="Banner">
                                            <h3>{{$t('lg_welcomeMsgHeadone')}}</h3>
                                            <p>{{$t('lg_welcomeMsg1')}}</p>       
                                        </div>
                                        <div class="carousel-item">
                                            <img src="../../../../static/fxView/images/login_trader_toolbox.svg" alt="Banner">
                                            <h3>{{$t('lg_welcomeMsgHeadtwo')}}</h3>
                                            <p>{{$t('lg_welcomeMsg2')}}</p>
                                        </div>
                                        <div class="carousel-item">
                                            <img src="../../../../static/fxView/images/login_download_platform.svg" alt="Banner">
                                            <h3>{{$t('lg_welcomeMsgHeadthree')}}</h3>
                                            <p>{{$t('lg_welcomeMsg3')}}</p>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <ul class="carousel-indicators mt-3">
                                        <li data-target="#demo" data-slide-to="0" class="active"></li>
                                        <li data-target="#demo" data-slide-to="1"></li>
                                        <li data-target="#demo" data-slide-to="2"></li>
                                    </ul>
                                </div>
                            </div>
                        </div> -->
                        <div class="col-12 col-md-8 d-flex vh_100 align-items-center">
                            <!--loader - message--->
                            <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
                            
                            <div class="sign_insec">
                                <div class="subtitle">
                                    <h3> {{$t('fp_resetPassword')}}</h3>
                                    <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                                </div>
                                <div class="stepForm" v-show='displayMessage'>
                                    <p>{{$t('rp_passwordHashMsz2')}}  <router-link to="/">  {{$t('rp_here')}} </router-link>{{$t('rp_toLogin')}}</p>
                                </div> 
                                <div class="stepForm" v-show='!displayMessage'>
                                    <div class="form-group field-wrapper">
                                        <input :type="inputtype" placeholder=" " v-model="password" class="float-field form-control" v-validate="{ required: true ,regex : /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?!.*[\\\/])(?=.*[!@#$%^&*])\S{6,24}$/ , is: confirmPassword }" name="password" :class="{ 'is-invalid': submitted && errors.has('password') }" ref="passwordInput" >
                                        <label for="password" class="float-label"> {{$t('lg_password')}}</label>
                                        <feather :type="iconType" class="toggle-password" @click.prevent="switchVisibility('1')"></feather> 
                                        <p class="error" v-for="error in errors.collect('password')">
											<span v-show="error == 'The password field is required.'">{{$t('reg_passwordFieldReq')}}</span>
											<span v-show="error == 'The password field format is invalid.'">{{$t('reg_passCharVal')}}</span>
										</p>
                                    </div> 
                                    <div class="form-group field-wrapper">
                                        <input :type="inputtype1" placeholder=" " v-model="confirmPassword" class="float-field form-control" v-validate="'required'" name="confirmPassword" :class="{ 'is-invalid': submitted && errors.has('confirmPassword') }" ref="confirmPasswordInput" >
                                        <label for="password" class="float-label">  {{$t('reg_conPassword')}}</label>
                                        <feather :type="iconType1" class="toggle-password" @click.prevent="switchVisibility('2')"></feather> 
                                        <p class="error" v-for="error in errors.collect('confirmPassword')">
                                            <span v-show="error == 'The confirmPassword field is required.'">{{$t('reg_ConfpasswordReq')}}</span>
                                            <span v-show="error == 'The confirmPassword confirmation does not match.'">{{$t('reg_newConfFieldSame')}}</span>
                                        </p>
                                    </div> 
                                    <div class="clearfix"></div>
                                    <div class=" d-flex justify-content-between align-items-center submitButton">
                                        <button class="prism_btn btn_sm" v-on:click.prevent="submit()"> {{$t('fp_resetPassword')}}</button>
                                        <div class="forgot_sec">
                                            <router-link :to="'/'" class="forgotpassword d-flex">
                                                <feather type="chevron-left" class="mr-1"></feather>{{$t('fp_backLogin')}} 
                                            </router-link>     
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- <div class="mt-3 contactsupport border-top pt-3 text-center">
                                    <h4 class="mb-3"> {{$t('rp_otherWayHelp')}}</h4>
                                    <div class="d-flex align-items-center justify-content-center">
                                        <div class="text-center">
                                            <a href="https://direct.lc.chat/13047510/" class="prism_btn btn_sm" target="_blank"> {{$t('rp_chatWithUs')}}</a>
                                        </div>
                                        <div class="text-center mx-3">
                                             {{$t('rp_or')}}
                                        </div>
                                        <div class="text-center">
                                            <router-link to="#"  class="prism_btn btn_sm darkBG"> {{$t('rp_callUs')}}</router-link>
                                        </div>
                                    </div>
                                </div>             -->

                                
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import i18n from '@/plugins/lang/i18n';
    export default {
        name: 'Forgot-password',
        data() {
            return {
                "password" : "",
                "confirmPassword":"",
                submitted: false,
                inputtype1: 'password',
                inputtype: 'password',
                iconType : 'eye-off',
                iconType1 : 'eye-off',
                showpassword: false,
                showpassword1: false,
                displayMessage: false,
                pageLoader : false,
                response_msg : '',
                msg_type : '',
            }
        },
        methods:{
            ...mapActions({
                _runResetPasswordFromHash: types.RUN_USER_RESET_PASSWORD_FROM_HASH
            }),
            switchVisibility(getData) {
                if(getData == '1'){
                    this.showpassword = !this.showpassword
                    if(this.showpassword){
                        this.inputtype = 'text'
                        this.iconType = 'eye'
                    }else{
                        this.inputtype = 'password'
                        this.iconType = 'eye-off'
                    } 
                }else{
                    this.showpassword1 = !this.showpassword1
                    if(this.showpassword1){
                        this.inputtype1 = 'text'
                        this.iconType1 = 'eye'
                    }else{
                        this.inputtype1 = 'password'
                        this.iconType1 = 'eye-off'
                    } 
                }
                
            },
            submit(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                "password": _that.password,
                                "cpassword": _that.confirmPassword,
                                "hash": _that.hash

                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runResetPasswordFromHash(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        },
        created(){
			this.hash = this.$route.params.hash
            //this.hash = this.$route.params.hash
            // console.log(params)            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/ResetPasswordFromHash.vue